import { makeStyles } from '@material-ui/core';
import { ITheme } from '../../../style/theme';
import { colors } from '../../../style/colors';

const useStyles = makeStyles<ITheme>((theme: ITheme) => ({
  mentorWrapper: {
    display: 'flex',
    padding: '16px 0',
  },
  mentorImage: {
    width: 48,
    height: 48,
    objectFit: 'cover',
    borderRadius: 60,
    marginRight: 8,
  },
  mentorTitleSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  yourHostLabel: {
    color: colors.darkGray,
    fontWeight: 700,
  },
  label: {
    fontWeight: 'bold',
  },
}));

export default useStyles;
